import { apiV2, wordpressRoot } from "./configFile"

export default function dateToReadableDate(date) {
  if (!date) return

  try {
    const goodDate = new Date(date)
    return `${goodDate.getDate()} ${numToMonth(goodDate.getMonth())}`
  } catch (e) {
    return ""
  }

}

function numToMonth(month) {
 switch (month) {
  case 0:
     return "janvier"
   case 1:
     return "février"
   case 2:
     return "mars"
   case 3:
     return "avril"
   case 4:
     return "mai"
   case 5:
     return "juin"
   case 6:
     return "juillet"
   case 7:
     return "août"
   case 8:
     return "septembre"
   case 9:
     return "octobre"
   case 10:
     return "novembre"
   case 11:
     return "decembre"
   default:
     return "Doesn't exists"
 }
}

export async function fetchBackground(mediaId) {
	const response = await fetch(
		wordpressRoot + apiV2 + 'media/' + mediaId
	)
	if (!response.ok) {
		return
	}
	return await response.json()
}

export async function fetchBackgroundWithPage(page) {
  if (!page || !Object.keys(page).length) return
  return fetchBackground(page.featured_media)
}
